import React from "react";
import { Link } from "react-router-dom";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Spinner } from "../../UI/States";
import { pageVisual, TILE_TONES } from "../homeIcons";

// Shared shell for homepage widgets: an icon + title row that links to the
// full page, then whatever compact content the widget renders. The icon and
// tint come from the page's area (homeIcons.js), so every widget gets one
// without passing anything extra.
const WidgetFrame = ({ title, to, children }) => {
  const { icon: Icon, tone } = pageVisual(to);
  return (
    <div className="app-card flex h-full min-h-[9.5rem] flex-col rounded-2xl border p-4">
      <Link
        to={to}
        className="group -m-1.5 mb-2.5 flex items-center gap-2.5 rounded-xl p-1.5 transition-colors hover:bg-[color:var(--app-hover)]"
      >
        <span
          className={`app-icon-tile h-8 w-8 rounded-[0.6rem] ${
            TILE_TONES[tone] || TILE_TONES.slate
          }`}
        >
          <Icon sx={{ fontSize: 18 }} />
        </span>
        <h3 className="min-w-0 flex-1 truncate text-[0.95rem] font-semibold tracking-tight">
          {title}
        </h3>
        <ChevronRightRoundedIcon
          className="app-muted shrink-0 transition group-hover:translate-x-0.5 group-hover:text-[color:var(--app-accent)]"
          sx={{ fontSize: 20 }}
        />
      </Link>
      <div className="min-h-0 flex-1">{children}</div>
    </div>
  );
};

// Consistent bits widgets can share.
export const WidgetStat = ({ value, label }) => (
  <div className="app-surface flex min-w-0 flex-col justify-between rounded-xl border px-3 py-2.5">
    <p className="text-xl font-semibold leading-tight tabular-nums tracking-tight">
      {value}
    </p>
    <p className="app-muted mt-0.5 text-[11px] font-medium leading-snug">
      {label}
    </p>
  </div>
);

// Loading / empty / error line. Loading copy ("Loading …") gets a small
// spinner so a tile that's still fetching doesn't read as "nothing here".
export const WidgetEmpty = ({ children }) => {
  const loading =
    typeof children === "string" && children.startsWith("Loading");
  return (
    <p className="app-muted flex items-center gap-2 py-1 text-sm">
      {loading && <Spinner size={14} />}
      {children}
    </p>
  );
};

export default WidgetFrame;
